<template>
<div class='card'>
    <div class='card-header'>
       <el-row type="flex" justify="center">
            <el-col :span="12">
                <label class='az-content-label' style='text-transform: none'>Cash at Bank
                  <span style="font-size:12px;font-weight:400">{{dateformats.getDay()}}</span>
                </label>
            </el-col>
            <el-col :span="8">
                <el-input 
                    style="fload:right"
                    size='mini'
                    v-model="message" 
                    prefix-icon="el-icon-search"
                    placeholder="Search">
                </el-input>
            </el-col>
            <el-col :span="4" >
                <span style="float:right">
                  <el-button size="mini" v-on:click="other.exportExcel('Cash at Bank.xlsx')">Excel</el-button>
                  <el-button size="mini" v-on:click="generateReport">PDF</el-button>
                </span>
            </el-col>
        </el-row>
        <p class="tx-12 pd-t-10">Alerts show when the fund’s cash at bank is above the limit (10% default) of the total fund value; and / or the cash balance is below a certain amount ($5000 default). Please click the numbers to reset cash limits if required.</p>
    </div>
   
    <div class='card-body tx-13' v-loading='loading'>
        <el-table
                :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                :header-cell-style="{color: '#7987a1'}"
                size="small"
                style="width: 100%;font-size:13px"
                :default-sort = "{prop: 'fund_name', order: 'ascending'}"
                >
                <el-table-column
                prop="fund_name"
                label="Fund Name"
                sortable
                style='font-weight:500;font-size:13px'
                >
                <template slot-scope="scope" >
                    <div style='font-weight:500'>
                    <router-link :to="{path:'/funddashboard/'+scope.row.fund_code,query:{name:scope.row.fund_name}}">{{isSample?'Sample Family Super Fund '+(index+1):scope.row.fund_name}} </router-link>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                prop="total_cash,cash_amount,fund_code"
                label='Cash at Bank'
                sortable
                >
                <template slot-scope="scope">
                    <div v-if="scope.row.total_cash<scope.row.amount===false">
                        <el-button type='text' @click="setting=!setting,reset=scope.row.fund_code" style="padding:0"><span class='tx-dark tx-13'>{{currentformats.AUformat(scope.row.total_cash)}}</span></el-button>
                    </div>
                    <div v-else>
                        <el-tooltip  class="item" effect="light" :content="'cash balance is below $'+scope.row.amount+'. Click to reset.'" placement="left-start">
                        <el-button type='text' @click="setting=!setting,reset=scope.row.fund_code" style="padding:0"><span class='tx-danger tx-13'>{{currentformats.AUformat(scope.row.total_cash)}}</span></el-button>
                    </el-tooltip>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                prop="limit,percentage,fund_code"
                label='Cash%'
                sortable
                >
                <template slot-scope="scope">
                    <div v-if="scope.row.limit<scope.row.percentage===false">
                        <el-button type='text' @click="setting=!setting,reset=scope.row.fund_code" style="padding:0;margin:0"><span class='tx-dark tx-13'>{{scope.row.percentage.toFixed(2)+'%'}}</span></el-button>
                    </div>
                    <div v-else>
                        <el-tooltip class="item" effect="light" :content="'above '+scope.row.limit+'% cash limits. Click to reset.'" placement="left-start">
                            <el-button type='text' @click="setting=!setting,reset=scope.row.fund_code" style="padding:0;margin:0"><span class='tx-danger tx-13'>{{scope.row.percentage.toFixed(2)+'%'}}</span></el-button>
                        </el-tooltip>
                    </div>
                </template>
                </el-table-column>
                
                <el-table-column
                prop="fund_code"
                label=''
                v-if="setting"
                >
                <template slot-scope="scope">
                    <div v-show="reset===scope.row.fund_code">
                        <el-form :inline="true" :model="form" class="demo-form-inline" size="mini">
                        <el-form-item label="Max cash percentage(%):">
                            <el-input-number v-model.number="form.limit" :max='100' :rules="[
                        { type: 'number',message: 'The number must be 0 - 100'}
                        ]"></el-input-number>
                        </el-form-item>
                        <el-form-item label="Cash low amount($)">
                            <el-input v-model="form.amount" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button class='bg-primary' type="primary" @click="onSubmit">OK</el-button>
                        </el-form-item>
                        </el-form>
                    </div>
                </template>
                </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 60px;">
            <el-pagination
                :current-page="currentPage"
                :page-size="pagesize"
                layout="total, prev, pager, next, jumper"
                :total="total"
                @current-change="current_change">
            </el-pagination>
            </div>
        
    </div>
    <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            filename="Cash at Bank"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="90%"
    
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf"
        >
        <section slot="pdf-content">
        <table id='table' class="table">
            <thead>
            <tr>
                <th>Fund Name</th>
                <th>Cash at Bank</th>
                <th>Cash%</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="cash in cash_list" :key="cash.fund_code" v-show="cash.fund_name.toLowerCase().match(message.toLowerCase())">
                <td style='font-weight:500'><router-link :to="{path:'/funddashboard/'+cash.fund_code,query:{name:cash.fund_name}}">{{cash.fund_name}} </router-link></td>
                <td v-show='cash.total_cash<cash.amount===false'>
                    <el-button type='text' @click="setting=!setting,reset=cash.fund_code" style="padding:0"><span class='tx-dark tx-13'>{{currentformats.AUformat(cash.total_cash)}}</span></el-button>
                </td>
                <td v-show='cash.total_cash<cash.amount'>
                    <el-tooltip  class="item" effect="light" :content="'cash balance is below $'+cash.amount+'. Click to reset.'" placement="left-start">
                        <el-button type='text' @click="setting=!setting,reset=cash.fund_code" style="padding:0"><span class='tx-danger tx-13'>{{currentformats.AUformat(cash.total_cash)}}</span></el-button>
                    </el-tooltip>
                </td>
                <td v-show='cash.limit<cash.percentage===false' >
                    <el-button type='text' @click="setting=!setting,reset=cash.fund_code" style="padding:0;margin:0"><span class='tx-dark tx-13'>{{cash.percentage.toFixed(2)+'%'}}</span></el-button>
                </td>
                <td v-show='cash.limit<cash.percentage' >
                    <el-tooltip class="item" effect="light" :content="'above '+cash.limit+'% cash limits. Click to reset.'" placement="left-start">
                        <el-button type='text' @click="setting=!setting,reset=cash.fund_code" style="padding:0;margin:0"><span class='tx-danger tx-13'>{{cash.percentage.toFixed(2)+'%'}}</span></el-button>
                    </el-tooltip>
                </td>
            </tr>
            </tbody>
        </table>
        </section>
        </vue-html2pdf>
</div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import other from '../../../utils/other'
import currentformats from '../../../utils/currentformats'
import dateformats from '../../../utils/dateformats'
export default {
    name:'cash',
    components: { 
        VueHtml2pdf,
    },
    data(){
        return{
            isSample:false,
            currentformats:currentformats,
            dateformats:dateformats,
            cash_list:[],
            setting:false,
            message:'',
            reset:'',
            form:{
                amount:'',
                limit:''
            },
            loading:true,
            total: 0,
            pagesize:15,
            currentPage:1,
            other:other
        }
    },
    computed:{
      tableData:function(){
        var message=this.message;
        if(message){
          return  this.cash_list.filter(function(dataNews){
            return Object.keys(dataNews).some(function(key){
              return String(dataNews[key]).toLowerCase().indexOf(message) > -1
            })
          })
        }
        return this.cash_list
      }
    },
    created(){
        this.getCashData();
    },
    methods:{
        getCashData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            let brand = localStorage.getItem('brand_code')
            this.isSample=userdetail['sample'];
            this.$api.adviserdashboard_api.cash(brand).then(response =>{
                this.cash_list = response.data['cash']
                this.total = this.cash_list.length
                this.loading=false
            });
        
        },
        current_change:function(currentPage){
            this.currentPage = currentPage;
        },
        generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },
    }
}
</script>
<style>
.el-form-item__label {
    font-size: 13px;
    margin-bottom:0;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 2px;
}
::v-deep .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #cdd4e0;
}
</style>